// IE11 support:
import 'core-js/stable';
import 'babel-polyfill';



// WEBPACK FOOTER //
// ./src/polyfills.js